import Edit from './NcEdit'
import Main from './NcMain'
import New from './NcNew'
import Show from './NcShow'

export default {
  Edit,
  Main,
  New,
  Show,
}
